import React from 'react';
import { getHidratationKey } from '@portal-internet/core';
import InnerHTML from 'dangerously-set-html-content';
import { useScript } from '../../../hooks/useScript';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import { TextProps } from './Text.types';
import styles from './text.module.scss';

export default function Text(props: Readonly<TextProps>) {
    const { text = '', className = null, estil = null, mida, tag = 'div', idDom, dataTestId, onClick } = props;
    const { isJavaScriptClientEnabled } = useScript();
    const hidratationKey = getHidratationKey(text);

    const stylesText = clsx(
        styles.text,
        !__isEmpty(estil) && styles[estil as string],
        !__isEmpty(mida) && styles[mida as string],
        !__isEmpty(className) && className
    );
    const CustomTag = tag as React.ElementType;
    const InnerHTMLComponent = InnerHTML as any;

    if (!text) return <></>;

    if (tag === 'div' && isJavaScriptClientEnabled) {
        return (
            <InnerHTMLComponent
                key={hidratationKey}
                className={stylesText}
                html={text}
                {...(idDom && { id: idDom })}
                data-testid={dataTestId}
            />
        );
    } else {
        return (
            <CustomTag
                key={hidratationKey}
                className={stylesText}
                dangerouslySetInnerHTML={{ __html: text }}
                {...(idDom && { id: idDom })}
                data-testid={dataTestId}
                onClick={onClick}
            ></CustomTag>
        );
    }
}
